export default { sha: '1560ce18cd3dc84e0d05931bbdc48b60f8ee68d0', buildNumber: 'undefined' }
